module.exports = __webpack_public_path__ + "img/p-one-step-09.75c83e5b.png";